import React from "react";
import styles from "./lastQuestions.module.scss";
import { useQISUGLastQuestions } from "@kunduz/feature-question-indexing";
import ArrowIcon from "@icons/arrowIcon.svg";
import { useTranslation } from "next-i18next";
import { QuestionItem } from "@kunduz/feature-question-indexing";
import { LoadingSkeleton } from "@kunduz/ui";
import { getQIUrl } from "@kunduz/utility-common";

export const LastQuestionsSUG = (props: Props) => {
  const LinkComponent = props.linkAs ?? "a";
  const { t } = useTranslation("questionIndexing");
  const { lastQuestions, lastQuestionsError, lastQuestionsLoading } =
    useQISUGLastQuestions(
      props.courseId,
      props.subjectId,
      props.id,
      props.lang,
    );

  if (!lastQuestions || lastQuestionsError) {
    return null;
  }

  if (lastQuestionsLoading) {
    return <LoadingSkeleton style={{ width: "100%", height: 200 }} />;
  }

  return (
    <div className={styles.lastQuestionsContainer}>
      <div className={styles.lastQuestionsHeader}>
        <div className={styles.lastQuestionTitle}>
          {t("question_indexing_question_recommendation_component_title", {
            subject: props.subjectName,
          })}
        </div>
        <LinkComponent
          href={getQIUrl({
            lang: props.lang,
            courseSlug: props.courseSlug,
            subjectSlug: props.subjectSlug,
          })}
          className={styles.viewAll}
          rel="nofollow"
        >
          {t(
            "question_indexing_question_recommendation_component_view_all_button",
          )}
          <ArrowIcon />
        </LinkComponent>
      </div>
      {lastQuestions.map((question) => (
        <QuestionItem
          courseName={question.course}
          description={question.text_content}
          imageUrl={question.image}
          imgAlt={question.text_content}
          subjectName={question.subject}
          url={getQIUrl({
            lang: props.lang,
            questionSlug: question.slug,
            questionId: question.id,
          })}
          key={question.id}
          linkAs={props.linkAs}
        />
      ))}
    </div>
  );
};

interface Props {
  id: number;
  courseSlug: string;
  subjectSlug: string;
  subjectName: string;
  courseId: number;
  subjectId: number;
  isMobile: boolean;
  lang: "tr" | "en";
  linkAs?: React.ElementType;
}
